export const GET_MERCHANT_PERMISSION= "GET_MERCHANT_PERMISSION"
export const GET_MERCHANT_PERMISSION_SUCCESS = "GET_MERCHANT_PERMISSION_SUCCESS"
export const GET_MERCHANT_PERMISSION_FAIL = "GET_MERCHANT_PERMISSION_FAIL"

export const GET_MERCHANT_SUBMERCHANTID= "GET_MERCHANT_SUBMERCHANTID"
export const GET_MERCHANT_SUBMERCHANTID_SUCCESS = "GET_MERCHANT_SUBMERCHANTID_SUCCESS"
export const GET_MERCHANT_SUBMERCHANTID_FAIL = "GET_MERCHANT_SUBMERCHANTID_FAIL"

export const GET_MERCHANT_PERMISSION_BYMERCHANTID = "GET_MERCHANT_PERMISSION_BYMERCHANTID"
export const GET_MERCHANT_PERMISSION_BYMERCHANTID_SUCCESS = "GET_MERCHANT_PERMISSION_BYMERCHANTID_SUCCESS"
export const GET_MERCHANT_PERMISSION_BYMERCHANTID_FAIL = "GET_MERCHANT_PERMISSION_BYMERCHANTID_FAIL"

export const MERCHANT_PERMISSION_API_ERROR = "MERCHANT_PERMISSION_API_ERROR"